
import * as Models from "../../ts/rlAdmin.models";
import * as Utils from "../../ts/rlAdmin.utils";
import * as Consts from "../../ts/rlAdmin.consts";

import { AdminConfigService } from "../../services/admin-config-service";
import { NotifyService } from "../../services/notify-service";
import { DateLocaleService } from "../../services/date-locale-service";
import { AclService } from "../../services/acl-service";

export class OverviewConfigController {
	static $inject = ["$scope", "$window", "$location", "$filter", "$q", "adminConfigService", "notifyService", "dateLocaleService", "aclService"];
	divContactName: Models.IDivSetting[];
	divContactEmail: Models.IDivSetting[];
	divContactContact: Models.IDivSetting[];
	techContactName: Models.IDivSetting[];
	techContactEmail: Models.IDivSetting[];
	techContactContact: Models.IDivSetting[];
	adminUser: boolean;
	emailValid: boolean;
	urlRedirect: Models.IDivSetting[];
	editDivContactName: Models.IDivSetting;
	editDivContactEmail: Models.IDivSetting;
	editDivContactContact: Models.IDivSetting;
	editTechContactName: Models.IDivSetting;
	editTechContactEmail: Models.IDivSetting;
	editTechContactContact: Models.IDivSetting;
	editUrlRedirect: Models.IDivSetting;
	createOverviewModel: boolean;
	emailRegex: RegExp;
	canEdit: boolean;

	storedKeys: Models.IDivSetting[] = [];
	deletedKeys: Models.IDivSetting[] = [];
	newKeyName: string;
	newKeyValue: string;

	reservedKeyNames: string[] = [];

	constructor(private $scope: ng.IScope, private $window: ng.IWindowService, private $location: ng.ILocationService, private $filter: ng.IFilterService,
		private $q: ng.IQService, private adminConfigService: AdminConfigService, private notifyService: NotifyService,
		private dateLocaleService: DateLocaleService, private aclService: AclService) {
		this.createOverviewModel = false;
		this.divContactName = [];
		this.divContactEmail = [];
		this.divContactContact = [];
		this.techContactName = [];
		this.techContactEmail = [];
		this.techContactContact = [];
		this.adminUser = true;
		this.emailValid = true;
		this.urlRedirect = [];
		this.emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
		this.canEdit = false;

		this.reservedKeyNames.push("divContactName");
		this.reservedKeyNames.push("divContactContact");
		this.reservedKeyNames.push("divContactEmail");
		this.reservedKeyNames.push("techContactContact");
		this.reservedKeyNames.push("techContactName");
		this.reservedKeyNames.push("techContactEmail");
		this.reservedKeyNames.push("divUrlRedirect");
		this.reservedKeyNames.push("billMethod");
		this.reservedKeyNames.push("billEmailAddress");
		this.reservedKeyNames.push("billContactName");
		this.reservedKeyNames.push("billBillingAddress");
		this.reservedKeyNames.push("billSuiteNumber");
		this.reservedKeyNames.push("billCity");
		this.reservedKeyNames.push("billState");
		this.reservedKeyNames.push("billCountry");
		this.reservedKeyNames.push("divBillID");
		this.reservedKeyNames.push("currency_value_set_id");
		this.reservedKeyNames.push("division_currency_value_id");

		$scope.$watch(() => this.editDivContactEmail, (newValue, oldValue) => {
			if (newValue != undefined && (!oldValue || newValue != oldValue)) {
				this.ValidateEmail(newValue.value)
			}
		}, true);
	}

	Init() {
		var promise1 = this.aclService.loadActivityAcls()
			.then((acls) => {
				this.canEdit = Utils.AclUtil.hasWriteAccess(acls, Consts.Acl.Activities._Site._DivAdmin.OverView);
			});

		var promise2 = this.adminConfigService.getDivSettingList()
			.then((result) => {
				this.divContactName = result.filter(s => s.key == "divContactName");
				this.divContactContact = result.filter(s => s.key == "divContactContact");
				this.divContactEmail = result.filter(s => s.key == "divContactEmail");
				this.techContactContact = result.filter(s => s.key == "techContactContact");
				this.techContactName = result.filter(s => s.key == "techContactName");
				this.techContactEmail = result.filter(s => s.key == "techContactEmail");
				this.urlRedirect = result.filter(s => s.key == "divUrlRedirect");

				//Remove all of the above settings from the results and list the rest as Stored Keys
				_.remove(result, r => _.contains(this.reservedKeyNames, r.key));

				this.storedKeys = result;
				//--
			});

		this.$q.all([promise1, promise2])
			.then(() => {
				if (_.isEmpty(this.divContactName) || _.isEmpty(this.divContactEmail) || _.isEmpty(this.divContactName)) {
					// this.setCompanyCurrency = true;
					alert("There is no division administrator set up. Please setup one now.");
				}
			});
	};

	ValidateEmail(email: string) {
		this.adminConfigService.adminEmail(email)
			.then((result) => {
				if (result.success) {
					this.adminUser = true;
				}
				else {
					this.adminUser = false;
				}
			});
	};

	Edit() {
		this.createOverviewModel = true;

		this.editDivContactName = this.divContactName[0];
		this.editDivContactEmail = this.divContactEmail[0];
		this.editDivContactContact = this.divContactContact[0];

		this.editTechContactName = this.techContactName[0];
		this.editTechContactEmail = this.techContactEmail[0];
		this.editTechContactContact = this.techContactContact[0];

		this.editUrlRedirect = this.urlRedirect[0];
	};

	Save() {
		try {
			this.createOverviewModel = false;

			this.notifyService.startProgress();
			if (_.isEmpty(this.divContactName) && this.editDivContactName !== undefined) {
				this.editDivContactName.key = "divContactName";
				this.adminConfigService.createDivSetting(this.editDivContactName)
					.then(result => {
						if (!result) {
							this.notifyService.notifyError("Error Div Admin Name Setting");
						}
					}).finally(() => {
						this.Init();
					});
			}
			else {
				this.adminConfigService.updateDivSetting(this.editDivContactName)
					.then(result => {
						if (!result) {
							this.notifyService.notifyError("Error Div Admin Name Setting");
						}
					}).finally(() => {
						this.Init();
					});
			}

			if (_.isEmpty(this.divContactEmail) && this.editDivContactEmail !== undefined) {
				this.editDivContactEmail.key = "divContactEmail";
				this.adminConfigService.createDivSetting(this.editDivContactEmail)
					.then(result => {
						if (!result) {
							this.notifyService.notifyError("Error Div Admin email Setting");
						}
					}).finally(() => {
						this.Init();
					});
			}
			else {
				this.adminConfigService.updateDivSetting(this.editDivContactEmail)
					.then(result => {
						if (!result) {
							this.notifyService.notifyError("Error Div Admin email Setting");
						}
					}).finally(() => {
						this.Init();
					});
			}

			if (_.isEmpty(this.divContactContact) && this.editDivContactContact !== undefined) {
				this.editDivContactContact.key = "divContactContact";
				this.adminConfigService.createDivSetting(this.editDivContactContact)
					.then(result => {
						if (!result) {
							this.notifyService.notifyError("Error Div Admin contact Setting");
						}
					}).finally(() => {
						this.Init();
					});
			}
			else {
				this.adminConfigService.updateDivSetting(this.editDivContactContact)
					.then(result => {
						if (!result) {
							this.notifyService.notifyError("Error Div Admin contact Setting");
						}
					}).finally(() => {
						this.Init();
					});
			}

			if (_.isEmpty(this.techContactName) && this.editTechContactName !== undefined) {
				this.editTechContactName.key = "techContactName";
				this.adminConfigService.createDivSetting(this.editTechContactName)
					.then(result => {
						if (!result) {
							this.notifyService.notifyError("Error Tech Admin Name Setting");
						}
					}).finally(() => {
						this.Init();
					});
			}
			else {
				this.adminConfigService.updateDivSetting(this.editTechContactName)
					.then(result => {
						if (!result) {
							this.notifyService.notifyError("Error Tech Admin Name Setting");
						}
					}).finally(() => {
						this.Init();
					});
			}

			if (_.isEmpty(this.techContactEmail) && this.editTechContactEmail !== undefined) {
				this.editTechContactEmail.key = "techContactEmail";
				this.adminConfigService.createDivSetting(this.editTechContactEmail)
					.then(result => {
						if (!result) {
							this.notifyService.notifyError("Error Tech Admin email Setting");
						}
					}).finally(() => {
						this.Init();
					});
			}
			else {
				this.adminConfigService.updateDivSetting(this.editTechContactEmail)
					.then(result => {
						if (!result) {
							this.notifyService.notifyError("Error Tech Admin email Setting");
						}
					}).finally(() => {
						this.Init();
					});
			}

			if (_.isEmpty(this.techContactContact) && this.editTechContactContact !== undefined) {
				this.editTechContactContact.key = "techContactContact";
				this.adminConfigService.createDivSetting(this.editTechContactContact)
					.then(result => {
						if (!result) {
							this.notifyService.notifyError("Error Tech Admin contact Setting");
						}
					}).finally(() => {
						this.Init();
					});
			}
			else {
				this.adminConfigService.updateDivSetting(this.editTechContactContact)
					.then(result => {
						if (!result) {
							this.notifyService.notifyError("Error Tech Admin contact Setting");
						}
					}).finally(() => {
						this.Init();
					});
			}

			if (_.isEmpty(this.urlRedirect) && this.editUrlRedirect !== undefined) {
				this.editUrlRedirect.key = "divUrlRedirect";
				this.adminConfigService.createDivSetting(this.editUrlRedirect)
					.then(result => {
						if (!result) {
							this.notifyService.notifyError("Error URL Setting");
						}
					}).finally(() => {
						this.Init();
					});
			}
			else {
				this.adminConfigService.updateDivSetting(this.editUrlRedirect)
					.then(result => {
						if (!result) {
							this.notifyService.notifyError("Error URL Setting");
						}
					}).finally(() => {
						this.Init();
					});
			}

			//Stored Keys
			var storedKeysPromises = [];
			this.storedKeys.forEach(sk => {
				if (sk.divSettingID == "-1") {
					//Create the key
					storedKeysPromises.push(this.adminConfigService.createDivSetting(sk));
				}
				else {
					//Update the key
					storedKeysPromises.push(this.adminConfigService.updateDivSetting(sk));
				}
			});

			this.$q.all(deleteStoredKeysPromises)
				.then(() => {
					this.deletedKeys = [];
				})
				.finally(() => {
					this.Init();
				});

			//Delete Stored Keys
			var deleteStoredKeysPromises = [];
			this.deletedKeys.forEach(dk => {
				if (dk.divSettingID != "-1") {
					deleteStoredKeysPromises.push(this.adminConfigService.deleteDivSetting(dk.divSettingID));
				}
			});

			this.$q.all(deleteStoredKeysPromises)
				.then(() => {
					this.deletedKeys = [];
				})
				.finally(() => {
					this.Init();
				});
			//--
		}
		catch (Exception) {
			alert(Exception);
		}
		finally {
			this.divContactName = [];
			this.divContactEmail = [];
			this.divContactContact = [];

			this.techContactName = [];
			this.techContactEmail = [];
			this.techContactContact = [];

			this.urlRedirect = [];

			this.editDivContactName = null;
			this.editDivContactEmail = null;
			this.editDivContactContact = null;

			this.editTechContactName = null;
			this.editTechContactEmail = null;
			this.editTechContactContact = null;

			this.editUrlRedirect = null;

			this.notifyService.endProgress();
			setTimeout(this.Init(), 5);
		}
	};

	Cancel() {
		this.Init();
	}

	AddStoredKey() {
		//Ensure that there is a key, we don't care if there is a value
		if (_.isEmpty(this.newKeyName)) {
			this.notifyService.notifyError("You cannot have an empty key name.");
			return;
		}

		//Ensure that the new key does not match a reserved key word
		if (_.contains(this.reservedKeyNames, this.newKeyName)) {
			this.notifyService.notifyError("You cannot have a stored key with the same name as a reserved key word.");
			return;
		}

		//Ensure that the new key is not a duplicate key
		if (this.storedKeys.find((k => k.key == this.newKeyName))) {
			this.notifyService.notifyError("You cannot have duplicate keys.");
			return;
		}

		var newKey: Models.IDivSetting = { divSettingID: "-1", key: this.newKeyName, value: this.newKeyValue };
		this.storedKeys.push(newKey);
		this.newKeyName = "";
		this.newKeyValue = "";
	}

	RemoveStoredKey(storedKey: Models.IDivSetting) {
		this.deletedKeys.push(storedKey);
		var index = this.storedKeys.indexOf(storedKey);
		this.storedKeys.splice(index, 1);
	}
}
